import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
	standalone: true,
	imports: [CommonModule, MatButtonModule],
	selector: 'feature-porto-bank-generic-error',
	template: `
		<div class="generic-error-container">
			<div class="header">
				<h2 class="title">{{ data.title }}</h2>
			</div>

			<div class="content">
				<p class="error-message">{{ data.error }}</p>
			</div>

			<div class="footer">
				<button mat-flat-button color="primary" (click)="clickBtn()">
					{{ data.btnMessage }}
				</button>
			</div>
		</div>
	`,
	styles: [
		`
			.generic-error-container {
				padding: 24px;
				display: flex;
				flex-direction: column;
				gap: 20px;
			}

			.header {
				.title {
					margin: 0;
					font-size: 20px;
					font-weight: 600;
					color: var(--content-primary);
				}
			}

			.content {
				.error-message {
					margin: 0;
					font-size: 14px;
					line-height: 1.5;
					color: var(--content-txt-secondary);
				}
			}

			.footer {
				display: flex;
				justify-content: flex-end;

				button {
					min-width: 120px;
				}
			}
		`,
	],
})
export class GenericErrorComponent {
	public dialogRef = inject(MatDialogRef<GenericErrorComponent>, { optional: true })
	public bottomSheetRef = inject(MatBottomSheetRef<GenericErrorComponent>, { optional: true })
	public data =
		inject(MAT_DIALOG_DATA, { optional: true }) ?? inject(MAT_BOTTOM_SHEET_DATA, { optional: true })

	public clickBtn = () => {
		if (this.data?.btnClick) {
			this.data.btnClick()
		}
		return this.bottomSheetRef?.dismiss() || this.dialogRef?.close()
	}
}
